import { Game } from "../types";

interface Props {
  factors: Game["factors"];
}

const DIR_COLOR = {
  good: "#22C55E",
  neutral: "#1535A0",
  bad: "#D42B2B",
};

function FactorRow({
  factor,
}: {
  factor: Game["factors"][keyof Game["factors"]];
}) {
  const barColor = DIR_COLOR[factor.dir];

  return (
    <div style={{ marginBottom: 12 }}>
      {/* label row */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          marginBottom: 5,
        }}
      >
        <div>
          <span
            style={{
              fontSize: "0.72rem",
              fontWeight: 600,
              color: "#0A1740",
            }}
          >
            {factor.label}
          </span>
          <span
            style={{
              fontSize: "0.65rem",
              color: "#8090B0",
              marginLeft: 6,
            }}
          >
            {factor.sub}
          </span>
        </div>
        <span
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "1rem",
            color: barColor,
            lineHeight: 1,
            marginLeft: 8,
            flexShrink: 0,
          }}
        >
          {factor.value}
        </span>
      </div>

      {/* progress bar */}
      <div
        style={{
          height: 5,
          background: "#EEF0F6",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${factor.score}%`,
            background: barColor,
            borderRadius: 3,
            transition: "width 0.5s ease",
          }}
        />
      </div>
    </div>
  );
}

export default function FactorBars({ factors }: Props) {
  return (
    <div
      style={{
        padding: "14px 20px 16px",
        background: "#FAFBFF",
        borderTop: "1px solid #EEF0F6",
      }}
    >
      <div
        style={{
          fontSize: "0.6rem",
          fontWeight: 700,
          letterSpacing: 2,
          textTransform: "uppercase",
          color: "#8090B0",
          marginBottom: 12,
        }}
      >
        Factor Breakdown
      </div>
      <FactorRow factor={factors.park} />
      <FactorRow factor={factors.pitcher} />
      <FactorRow factor={factors.slg} />
      <FactorRow factor={factors.total} />
      <FactorRow factor={factors.weather} />
    </div>
  );
}
